"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AriForm_1 = require("../../AriForm");
const NestedComponent_1 = __importDefault(require("../_classes/nested/NestedComponent"));
class FieldsetComponent extends NestedComponent_1.default {
    static schema(...extend) {
        return NestedComponent_1.default.schema({
            label: 'Field Set',
            key: 'fieldSet',
            type: 'fieldset',
            legend: '',
            components: [],
            input: false,
            persistent: false
        }, ...extend);
    }
    static get builderInfo() {
        return {
            title: 'Field Set',
            icon: 'th-large',
            group: 'layout',
            documentation: '/userguide/form-building/layout-components#field-set',
            showPreview: false,
            weight: 20,
            schema: FieldsetComponent.schema()
        };
    }
    static savedValueTypes() {
        return [];
    }
    get defaultSchema() {
        return FieldsetComponent.schema();
    }
    // get className() {
    //   return `${this.transform('class', 'form-group')} ${super.className}`;
    // }
    get className() {
        const paddingLeft = this.component.paddingLeft && `${AriForm_1.AriForm.tailwindPrefix}pl-[${this.component.paddingLeft || 0}]`;
        const paddingRight = this.component.paddingRight && `${AriForm_1.AriForm.tailwindPrefix}pr-[${this.component.paddingRight || 0}]`;
        const marginTop = this.component.marginTop && `${AriForm_1.AriForm.tailwindPrefix}mt-[${this.component.marginTop || '0'}]`;
        const marginRight = this.component.marginRight && `${AriForm_1.AriForm.tailwindPrefix}mb-[${this.component.marginRight || '1rem'}]`;
        const waperWidth = this.component.setWitdhElement && `${AriForm_1.AriForm.tailwindPrefix}w-[${this.component.waperWidth || '100%'}]`;
        const wrapItems = this.component.isWrapItems && `custom-wrap-items`;
        return [
            super.className,
            paddingLeft,
            paddingRight,
            marginTop,
            marginRight,
            waperWidth,
            wrapItems
        ].join(' ');
    }
    get templateName() {
        return 'fieldset';
    }
    constructor(...args) {
        super(...args);
        this.noField = true;
    }
}
exports.default = FieldsetComponent;
